import React from 'react'
import Reflux from 'reflux'
// import FontAwesome from 'react-fontawesome'
import { Alert, Row, Col } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeDetailsPreheat extends Reflux.Component {
	constructor(props) {
		super(props)

		this.state = {
			isEditing: false
		}

		this.store = CurrentRecipeStore
		this.storeKeys = ['preheat_temp']

		this.toggleEdit = this.toggleEdit.bind(this)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	toggleEdit = () => {
		this.setState({ isEditing: !this.state.isEditing })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const preheatTemp = (this.state.preheat_temp !== null)
			? this.state.preheat_temp
			: '...'

		return (
			this.state.preheat_temp !== null
			&& this.state.preheat_temp !== ''
			&& this.state.preheat_temp !== 0
		)
			? (
				<Row>
					<Col xs={12}>
						<Alert color="warning" style={{ display: 'table', width: '100%' }}>
							<strong>
								Preheat oven to {preheatTemp} degrees
							</strong>
						</Alert>
					</Col>
				</Row>
			)
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/preheat.jsx